export const featureFlags = {
  showLogo: false,
}
